import { styled } from '@linaria/react'

export const BottomSheetContentLayout = styled.div`
  & > * + * {
    margin-top: var(--spacing-24px);
  }
`
